import { useMemo } from 'react';

import { LocationDayScheduleFragment } from '@occc/graphql';
import {
  FormattedScheduleListItem,
  useLocationScheduleListOnly,
} from '@occc-app/lib/util-location-schedule';

import { getTimeSchedule } from './location-schedule-card.utils';

import { LocationSectionBaseParams } from '../../retailer-network-location-details-page.types';

export type LocationScheduleReturns = {
  data: {
    schedule: LocationDayScheduleFragment[];
    scheduleList: FormattedScheduleListItem[];
  };
};

export const useLocationSchedule = (params: LocationSectionBaseParams): LocationScheduleReturns => {
  const { location } = params;

  const workingHours = useMemo(
    () => location?.hoursOfOperationGroup?.hours || [],
    [location?.hoursOfOperationGroup?.hours],
  );

  const { list } = useLocationScheduleListOnly({
    workingHours,
  });

  const formattedScheduleList = useMemo(() => {
    return list.map((item) => {
      const period = [item.periodStartTitle, item.periodEndTitle].filter(Boolean).join(' - ');
      const timeSchedule = getTimeSchedule(item);

      return {
        period,
        timeSchedule,
      };
    });
  }, [list]);

  return useMemo(
    () => ({
      data: {
        schedule: workingHours,
        scheduleList: formattedScheduleList,
      },
    }),
    [formattedScheduleList, workingHours],
  );
};
